	// cookie compliance banner
export function cookieCompliance() {
		if (document.querySelector('.site-farlo-ui-biscuit-banner__button')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');
			});
		}
	}
